import Big from 'big.js';

export const subtractMoney = (a = 0, b = 0) => Number(Big(Number(a)).sub(Number(b)));

export const clampToZero = (value) => (value < 0 ? 0 : value);

export const formatWithCurrency = ({
  symbol,
  amount,
  currency,
  formatMoney
}) => `${symbol}${formatMoney(amount)} ${currency}`;
